(()=>{
 'use strict';
 if(window.DulchefsAnalyticsInstalled)return;window.DulchefsAnalyticsInstalled=true;
 const config=document.getElementById('dulchefs-analytics-context');if(!config)return;
 let context;try{context=JSON.parse(config.textContent);}catch{return;}
 if(!['portal','product'].includes(context.metric)||!/^\d+$/.test(context.resourceId))return;
 const models=new Set((context.modelIds||[]).map(String));
 const allowed=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
 let pageSent=false,attempt=null;const timers=new Set();
 function event(metric,eventId=crypto.randomUUID()){
  if(!allowed())return;
  const body=JSON.stringify({metric,resourceId:context.resourceId,eventId,consent:true});
  async function send(retry=0){
   if(!allowed())return;
   try{const response=await fetch('/apps/dulchefs-favoritos/analytics',{method:'POST',headers:{'Content-Type':'application/json'},body,credentials:'same-origin',keepalive:true});if(response.ok||response.status<500&&response.status!==429)return;}catch{}
   if(retry<2&&allowed()){const timer=setTimeout(()=>{timers.delete(timer);send(retry+1);},1500*(retry+1));timers.add(timer);}
  }
  send();
 }
 function page(){if(!pageSent&&allowed()){pageSent=true;event(context.metric);}}
 document.addEventListener('visitorConsentCollected',()=>{if(!allowed()){for(const t of timers)clearTimeout(t);timers.clear();attempt=null;}else page();});
 window.addEventListener('pageshow',e=>{if(e.persisted){pageSent=false;page();}});
 // The theme's external-viewer control launches Quick Look or Scene Viewer.
 document.addEventListener('click',e=>{
  const button=e.target.closest?.('[data-shopify-xr]');
  if(context.metric!=='product'||!e.isTrusted||!button||button.disabled||button.hidden||button.getAttribute('aria-disabled')==='true'||!allowed()||!window.ShopifyXR||!models.has(button.getAttribute('data-shopify-model3d-id')))return;
  attempt={id:crypto.randomUUID(),at:Date.now()};event('ar',attempt.id);
 },true);
 const bound=new WeakSet();
 function bind(){document.querySelectorAll('model-viewer').forEach(model=>{if(bound.has(model)||!models.has(model.closest('product-model')?.getAttribute('data-media-id')))return;bound.add(model);model.addEventListener('ar-status',e=>{
  if(context.metric!=='product')return;
  if(e.detail?.status==='session-started'){
   const id=attempt&&Date.now()-attempt.at<30000?attempt.id:crypto.randomUUID();event('ar',id);attempt={id,at:Date.now()};
  }else if(['not-presenting','failed'].includes(e.detail?.status))attempt=null;
 });});}
 const observer=new MutationObserver(bind);observer.observe(document.documentElement,{childList:true,subtree:true});bind();
 function start(){page();
 if(!window.Shopify?.customerPrivacy&&window.Shopify?.loadFeatures)Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)page();});}
 start();window.addEventListener('load',start);
})();
